export class SendGopModel{
  caseId: number;
  serviceOrderId: number;
  preferredLanguage: string;
}
